import { useMemo } from 'react';

import { TTabOption } from './tabs.types';

const useValidateTabs = <T>(tabs: TTabOption<T>[]) => {
  return useMemo(() => {
    const valueCounts: Record<string, number> = {};
    // make sure each tab has a unique value
    return tabs.filter((tab) => {
      if (typeof tab.value !== 'string' || !tab.value?.trim()?.length) {
        console.warn('Tabs must have a valid string value but received', JSON.stringify(tab, null, 2));
        return false;
      }
      // if the value is not unique, warn the user
      if (valueCounts[tab.value] > 0) {
        console.warn(`Duplicate tab value found: ${tab.value}`);
        return false;
      }

      if (!(tab.value in valueCounts)) {
        valueCounts[tab.value] = 0;
      } else {
        valueCounts[tab.value]++;
      }

      return true;
    });
  }, [tabs]);
};

export default useValidateTabs;
